import type { RegistryEntry } from '../types';

export const elevenlabsConfigs: Record<string, RegistryEntry> = {
  'elevenlabs-eleven-v3': {
    options: [
      {
        key: 'stability',
        label: 'audio.stability',
        type: 'slider',
        min: 0,
        max: 1,
        step: 0.01,
        default: 0.5,
        group: 'basic',
      },
      {
        key: 'similarity',
        label: 'audio.similarity',
        type: 'slider',
        min: 0,
        max: 1,
        step: 0.01,
        default: 1,
        group: 'basic',
      },
      {
        key: 'use_speaker_boost',
        label: 'audio.speaker_boost',
        type: 'switch',
        default: true,
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      stability: typeof ui.stability === 'number' ? ui.stability : 0.5,
      similarity: typeof ui.similarity === 'number' ? ui.similarity : 1,
      use_speaker_boost:
        typeof ui.use_speaker_boost === 'boolean' ? ui.use_speaker_boost : true,
    }),
  },
  'elevenlabs-music': {
    options: [
      {
        key: 'duration_seconds',
        label: 'audio.duration_seconds',
        type: 'slider',
        min: 5,
        max: 300,
        step: 1,
        default: 30,
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'audio.output_format',
        type: 'select',
        options: [
          { label: 'MP3 Standard', value: 'mp3_standard' },
          { label: 'MP3 High Quality', value: 'mp3_high_quality' },
          { label: 'WAV 16kHz', value: 'wav_16khz' },
          { label: 'WAV 22kHz', value: 'wav_22khz' },
          { label: 'WAV 24kHz', value: 'wav_24khz' },
          { label: 'WAV CD Quality', value: 'wav_cd_quality' },
        ],
        default: 'mp3_standard',
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      duration_seconds: typeof ui.duration_seconds === 'number' ? ui.duration_seconds : 30,
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'mp3_standard',
    }),
  },
  'elevenlabs-voice-changer': {
    options: [
      {
        key: 'remove_background_noise',
        label: 'audio.remove_background_noise',
        type: 'switch',
        default: false,
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => ({
      remove_background_noise:
        typeof ui.remove_background_noise === 'boolean' ? ui.remove_background_noise : false,
    }),
  },
};